module.exports = __webpack_public_path__ + "img/layers-three-02.4e6af400.svg";